import { GraphqlStoreBase } from "../GraphqlStoreBase";
import gql from "graphql-tag";
const latestThermostatValuesStoreDocument = gql `
  query LatestThermostatValuesStore {
    getLatestThermostatValues {
      id
      deviceTime
      currentActions
      temperature
      humidity
      allowedActions
      setPointHeat
      setPointCool
      setPointCirculateAbove
      setPointCirculateBelow
    }
  }
`;
export class LatestThermostatValuesStore extends GraphqlStoreBase {
    constructor(authStore, apolloClient) {
        super("LatestThermostatValues", authStore, apolloClient, latestThermostatValuesStoreDocument, (queryData) => {
            return queryData.getLatestThermostatValues;
        }, (latestValue) => {
            // Rehydrate Date types
            return Object.assign(Object.assign({}, latestValue), { deviceTime: new Date(latestValue.deviceTime) });
        });
    }
}
//# sourceMappingURL=index.js.map